export default __webpack_public_path__ + "static/media/valo-motion-icon.98878167.svg";